import { every, identity } from 'lodash/fp';

import chuck from './chuck';
import flaggedItem from '../../../../../../../CopyStylesModal/isValidTargetItem/validators/flaggedItem';
import specialtyShape from '../../../../../../../CopyStylesModal/isValidTargetItem/validators/specialtyShape';

export default item => every(
  identity,
  [
    chuck(item),
    flaggedItem.check(undefined, item),
    specialtyShape.check(undefined, item),
  ],
);
